import { Link } from 'react-router-dom'
import './Services.css'

const services = [
  {
    id: 'custom',
    icon: '🖊️',
    title: 'Custom Tattoos',
    description:
      "Every design is created from scratch, built around you. From concept sketches to final ink.",
    tags: ['Traditional', 'Neo-Trad', 'Illustrative', 'Black & Grey'],
    cta: { label: 'Book Custom', to: '/book' },
  },
  {
    id: 'therapy',
    icon: '🌿',
    title: 'Tattoo Therapy',
    description:
      "A considered, gentle approach for clients working through something meaningful. Tattoo Therapy sessions are thoughtfully paced and designed to feel safe, personal, and empowering.",
    tags: ['Healing', 'Memorial', 'Empowerment', 'Cover-Up'],
    cta: { label: 'Learn More', to: '/tattoo-therapy' },
    featured: true,
  },
  {
    id: 'touchup',
    icon: '✨',
    title: 'Touch ups and reworks – ‘or a cover-up that needs to be revived',
    description:
      "Faded ink, old work that needs love, or a cover-up that needs to actually look incredible, bring it in. I can assess, plan, and revive almost anything.",
    tags: ['Cover-Ups', 'Fading', 'Colour Refresh', 'Rework'],
    cta: { label: 'Get in Touch', to: '/contact' },
  },
]

export default function Services() {
  return (
    <section className="services section" id="services" aria-labelledby="services-heading">
      <div className="container">
        {/* Section header */}
        <div className="services__header">
          <span className="services__eyebrow">What I Do</span>
          <h2 className="services__heading" id="services-heading">
            Services &amp;
            <span className="services__heading-script"> Specialties</span>
          </h2>
          <p className="services__intro">
            Whether you're after a bold statement piece, a deeply personal design,
            or something that needs a second life, there's a service for that.
          </p>
        </div>

        {/* Cards */}
        <div className="services__grid" role="list">
          {services.map((service) => (
            <article
              key={service.id}
              className={`services__card${service.featured ? ' services__card--featured' : ''}`}
              role="listitem"
            >
              <div className="services__card-icon" aria-hidden="true">
                {service.icon}
              </div>
              <h3 className="services__card-title">{service.title}</h3>
              <p className="services__card-desc">{service.description}</p>

              <ul className="services__tags" aria-label={`${service.title} specialties`}>
                {service.tags.map((tag) => (
                  <li key={tag} className="services__tag">
                    {tag}
                  </li>
                ))}
              </ul>

              <Link to={service.cta.to} className="services__card-cta">
                {service.cta.label}
                <span aria-hidden="true"> →</span>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
